import { memo, useCallback } from "react";

import { ColorPalette } from "@/components/ui/color";

const RecommendColors = [
	{
		backgroundColor: "#FFECEC",
		primaryColor: "#84C6BA",
		fontColor: "#000000",
	},
	{
		backgroundColor: "#FFFADF",
		primaryColor: "#F4A929",
		fontColor: "#000000",
	},
	{
		backgroundColor: "#CBBEB6",
		primaryColor: "#9D484F",
		fontColor: "#000000",
	},
	{
		backgroundColor: "#CDE0E4",
		primaryColor: "#4188BB",
		fontColor: "#000000",
	},
	{
		backgroundColor: "#5E7974",
		primaryColor: "#003B4D",
		fontColor: "#FFFFFF",
	},
	{
		backgroundColor: "#182D44",
		primaryColor: "#AD9A68",
		fontColor: "#FFFFFF",
	},
	{
		backgroundColor: "#908D89",
		primaryColor: "#65A664",
		fontColor: "#FFFFFF",
	},
	{
		backgroundColor: "#909CA7",
		primaryColor: "#DE773E",
		fontColor: "#FFFFFF",
	},
];

type Props = {
	onClickRecommendColors: (colorBackground: string, colorPrimary: string, colorFont: string) => void;
};

export const RecommendColorList = memo(({ onClickRecommendColors }: Props) => {
	const handleClickRecommendColors = useCallback(
		(colorBackground: string, colorPrimary: string, colorFont: string) => () => {
			onClickRecommendColors(colorBackground, colorPrimary, colorFont);
		},
		[onClickRecommendColors],
	);

	return (
		<div className="space-y-4">
			<h5 className="font-bold">おすすめの色</h5>
			<div className="grid grid-cols-2 gap-4 desktop:grid-cols-4">
				{RecommendColors.map((color, index) => {
					const handleClick = handleClickRecommendColors(
						color.backgroundColor,
						color.primaryColor,
						color.fontColor,
					);

					return (
						<div
							key={index}
							className="flex cursor-pointer items-center justify-center gap-x-1 hover:opacity-50"
							onClick={handleClick}
						>
							<ColorPalette
								color={color.backgroundColor}
								size="small"
								sx={["border", "border-zinc-400"]}
							/>
							<ColorPalette color={color.primaryColor} size="small" sx={["border", "border-zinc-400"]} />
							<ColorPalette color={color.fontColor} size="small" sx={["border", "border-zinc-400"]} />
						</div>
					);
				})}
			</div>
		</div>
	);
});
